import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-menu2",
  "use": "icon-menu2-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-menu2\"><path d=\"M920.1 291.8h-820c-18.8 0-34-15.2-34-34s15.2-34 34-34h820c18.8 0 34 15.2 34 34s-15.2 34-34 34zM549.1 547.2h-449c-18.8 0-34-15.2-34-34s15.2-34 34-34h449c18.8 0 34 15.2 34 34s-15.2 34-34 34zM783.4 812.4H100.1c-18.8 0-34-15.2-34-34s15.2-34 34-34h683.3c18.8 0 34 15.2 34 34s-15.2 34-34 34z\" fill=\"\" p-id=\"4294\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol